<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import CustomLoader from "@/components/widgets/custom-loader";
import CustomFilter from "@/components/widgets/custom-filter";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Marks Filters per Subject",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    CustomLoader,
    CustomFilter,
  },
  data() {
    return {
      title: "Mark Filters Per Subject",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Marks Filters Per Subject",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "student",
          label: "Student's Name",
          sortable: true,
        },
        {
          key: "stream",
          label: "Stream",
          sortable: true,
        },
        {
          key: "sets_marks",
          label: "Subject Marks",
          sortable: true,
        },
      ],
      subjectMarks: {
        class: "",
        term: "",
        year: "",
        subject: "",
        stream: "",
      },
    };
  },
  computed: {
    ...mapGetters("marks", [
      "SaveStatus",
      "getSubMarksFilters",
      "getCurrentClass",
      "getCurrentSub",
      "getYears",
    ]),
    ...mapGetters("classes", [
      "AllClasses",
      "GetClassSubjects",
      "AllClassStreams",
    ]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.getSubMarksFilters.length
        ? this.getSubMarksFilters.length
        : 1;
    },
  },
  watch: {
    SaveStatus(newVal) {
      if (!newVal) {
        this.resetError();
        // this.closeModal(this.modal);
      }
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows =
      this.getSubMarksFilters.length > 0 ? this.getSubMarksFilters.length : 1;
  },
  methods: {
    ...mapActions({
      FetchMarksSubFilters: "marks/fetchMarksSubFilters",
      FetchYears: "marks/fetchYear",
      FetchClasses: "classes/fetchClasses",
      FetchStreams: "classes/fetchStreams",
      FetchSets: "coursework/fetchSets",
      FetchClassStreams: "classes/fetchClassStreams",
      FetchClassSubjects: "classes/fetchClassSubjects",
    }),

    submitSubjectMarks() {
      this.FetchMarksSubFilters(this.subjectMarks);
    },
    fetchStreamsinClass(event) {
      const id = event.target.value;
      const classSelected = { id };
      //fetching class streams
      this.FetchClassStreams(classSelected);
    },
    fetchClassSub(event) {
      const id = event.target.value;
      const classSelected = { id };
      //fetching class subjects
      this.FetchClassSubjects(classSelected);
    },
    fetchStreamsSubject(event) {
      this.fetchStreamsinClass(event);
      this.fetchClassSub(event);
    },

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.getSubMarksFilters.length
        ? this.getSubMarksFilters.length
        : 1;
      this.currentPage = 1;
    },

    resetError() {
      this.nameError = "";
    },
  },
  created() {
    this.FetchYears();
    this.FetchClasses();
    this.FetchStreams();
    this.FetchSets();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('advanced_marks_reports')
        )
      "
    >
      <CustomFilter>
        <form @submit.prevent="submitSubjectMarks()">
          <div class="row">
            <div class="form-group col-md-2">
              <div class="form-group">
                <label for=""
                  >Select Year <small class="text-danger">*</small></label
                >
                <select
                  class="form-control form-control-sm"
                  v-model="subjectMarks.year"
                  name=""
                  id=""
                >
                  <option value="" selected disabled>Select Year</option>
                  <option
                    v-for="(schyear, index) in getYears"
                    :value="schyear.year"
                    :key="index"
                  >
                    {{ schyear.year }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group col-md-2">
              <div class="form-group">
                <label for=""
                  >Select Class <small class="text-danger">*</small></label
                >
                <select
                  required
                  class="form-control form-control-sm"
                  v-model="subjectMarks.class"
                  @change="fetchStreamsSubject($event)"
                  name=""
                  id=""
                >
                  <option value="" selected disabled>Select Class</option>
                  <option
                    v-for="(classes, index) in AllClasses"
                    :key="index"
                    :value="classes.id"
                  >
                    {{ classes.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group col-md-2">
              <div class="form-group">
                <label for=""
                  >Select Term <small class="text-danger">*</small></label
                >
                <select
                  required
                  class="form-control form-control-sm"
                  v-model="subjectMarks.term"
                  name=""
                  id=""
                >
                  <option value="" selected disabled>Select Term</option>
                  <option value="1">Term 1</option>
                  <option value="2">Term 2</option>
                  <option value="3">Term 3</option>
                </select>
              </div>
            </div>
            <div class="form-group col-md-2">
              <div class="form-group">
                <label for=""
                  >Select Subject <small class="text-danger">*</small></label
                >
                <select
                  required
                  class="form-control form-control-sm"
                  v-model="subjectMarks.subject"
                  name=""
                  id=""
                >
                  <option value="" selected disabled v-if="SaveStatus">
                    Fetching Subjects...
                  </option>
                  <option value="" selected disabled v-else>
                    Select Subject
                  </option>
                  <option
                    v-for="(subject, index) in GetClassSubjects"
                    :key="index"
                    :value="subject.id"
                  >
                    {{ subject.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group col-md-2">
              <div class="form-group">
                <label for="">Select Stream</label>
                <select
                  class="form-control form-control-sm"
                  v-model="subjectMarks.stream"
                  name=""
                  id=""
                >
                  <option value="" selected disabled v-if="SaveStatus">
                    Fetching Streams...
                  </option>
                  <option value="" selected disabled v-else>
                    Stream (Optional)
                  </option>
                  <option
                    v-for="(stream, index) in AllClassStreams"
                    :value="stream.id"
                    :key="index"
                  >
                    {{ stream.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group col-md-2 mt-4">
              <button
                type="submit"
                disabled
                class="btn btn-sm btn-outline-primary mt-1"
                v-if="SaveStatus"
              >
                <b-spinner
                  variant="primary"
                  small
                  label="Fetching Data..."
                ></b-spinner>
                Fetching Data...
              </button>
              <button
                v-else
                type="submit"
                size="sm"
                class="btn btn-sm btn-outline-primary mt-1"
              >
                <i class="fa fa-check"></i>
                Submit Filers
              </button>
            </div>
          </div>
        </form>
      </CustomFilter>
      <CustomLoader v-if="SaveStatus"></CustomLoader>
      <div class="col-12" v-else>
        <div class="card" v-if="getSubMarksFilters">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3 class="card-title text-primary">
                  Exam Marks of Term {{ subjectMarks.term }},
                  {{ getCurrentClass.name }} in {{ subjectMarks.year }} For
                  {{ getCurrentSub.name }}
                </h3>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-md-12 mt-4 custom-vert">
                    <div class="row mt-2">
                      <div class="col-sm-12 col-md-6">
                        <div
                          id="tickets-table_length"
                          class="dataTables_length"
                        >
                          <label class="d-inline-flex align-items-center">
                            Show&nbsp;
                            <b-form-select
                              class="form-select form-select-sm"
                              v-model="perPage"
                              size="sm"
                              :options="pageOptions"
                            ></b-form-select
                            >&nbsp;entries
                          </label>
                        </div>
                      </div>

                      <div class="col-sm-12 col-md-6">
                        <div
                          id="tickets-table_filter"
                          class="dataTables_filter text-md-end"
                        >
                          <label class="d-inline-flex align-items-center">
                            Search:
                            <b-form-input
                              v-model="filter"
                              type="search"
                              placeholder="Search..."
                              class="form-control form-control-sm ms-2"
                            ></b-form-input>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="table-responsive mb-0">
                      <b-table
                        class="datatables"
                        :items="getSubMarksFilters"
                        :fields="fields"
                        responsive="sm"
                        :per-page="perPage"
                        :current-page="currentPage"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        :filter="filter"
                        :filter-included-fields="filterOn"
                        @filtered="onFiltered"
                      >
                        <template #cell(index)="data">
                          {{ data.index + 1 }}
                        </template>
                        <template #cell(student)="data">
                          {{ data.item.student.name }}
                        </template>
                        <template #cell(stream)="data">
                          {{ data.item.stream.name }}
                        </template>
                        <template #cell(sets_marks)="data">
                          <table class="table">
                            <tbody>
                              <tr style="border-color: transparent">
                                <td
                                  v-for="(allSetMarks, index) in data.item
                                    .sets_marks"
                                  :key="index"
                                >
                                  <b>{{ allSetMarks.set.short }}</b
                                  ><br />
                                  <span>{{ allSetMarks.marks }}</span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </template>
                      </b-table>
                    </div>
                    <div class="row">
                      <div class="col">
                        <div
                          class="
                            dataTables_paginate
                            paging_simple_numbers
                            float-end
                          "
                        >
                          <ul class="pagination pagination-rounded mb-0">
                            <b-pagination
                              v-model="currentPage"
                              :total-rows="rows"
                              :per-page="perPage"
                            ></b-pagination>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card" v-else>
          <div class="card-body">
            <div class="alert alert-primary text-center" role="alert">
              <strong>Please filter students using the above inputs.</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
